import React, { useState } from "react";
import { Model, WayLine, WayLineModel } from "../../shared/utils/cropr";
import { gettext } from "../../shared/utils/legacy";
import { Modal } from "react-bootstrap";
import GeometryModelPreview from "../../shared/components/GeometryModelPreview";
import LabeledField from "../../shared/forms/LabeledField";
import ModalHeader from "../../shared/components/ModalHeader";
import GeneralError from "../../shared/forms/GeneralError";
import ModelEditModalFooter from "../../shared/components/ModelEditModalFooter";
import { ModelSubmitFormik, PropertiesModalProps } from "../../shared/utils/modals";
import cropr from "../../shared/utils/cropr";

const WayLinePropertiesModal = ({ model, onSave, onHide }: PropertiesModalProps<WayLineModel>) => {
  const [show, setShow] = useState(true);
  const typeName = gettext("Way line");

  function hide() {
    setShow(false);
    onHide?.();
  }

  const initialValues: WayLine = {
    name: model.get("name") || Model.Storage.generateName(),
    description: model.get("description"),
    active: model.get("active"),
    date: model.get("date"),
    geometry: model.get("geometry") || model.get("addshape_geometry"),
  };
  const cropFields = model.getCropFields();
  const props = {
    hide,
    typeName,
    model,
    collection: cropr.way_lines,
    permission: cropr.permissions.crop_f, // there are no specific permissions for way lines so using crop fields permissions instead
  };
  return (
    <Modal className="modal-md dfi-modal" show={show} onHide={hide} backdrop="static">
      <ModelSubmitFormik initialValues={initialValues} onSave={onSave} {...props}>
        {({ values, handleSubmit, isSubmitting, errors }) => (
          <form onSubmit={handleSubmit}>
            <ModalHeader
              title={model.id ? gettext("Edit way line properties") : gettext("Create way line")}
            />
            <Modal.Body>
              <GeneralError errors={errors} />
              <div className="row">
                <div className="col-4">
                  <GeometryModelPreview model={model} titleCenter={false}>
                    {cropr.toLocaleFixed(model.getLength(), 0)} {gettext("meter")},{" "}
                    {cropr.toLocaleFixed(model.getDisplayAngle(), 2)} &deg;
                  </GeometryModelPreview>
                </div>
                <div className="col-8">
                  {cropFields.map((cropField) => (
                    <div key={cropField.get("id")} className="row ml-0">
                      <GeometryModelPreview model={cropField} size={30}>
                        {" "}
                      </GeometryModelPreview>
                      {cropField.get("name")}
                    </div>
                  ))}
                  <LabeledField
                    label={gettext("Name")}
                    name="name"
                    type="text"
                    maxLength={50}
                    placeholder={gettext("Enter a way line name")}
                  />
                  <LabeledField label={gettext("Description")} name="description" type="textarea" />
                  <LabeledField label={gettext("Date")} name="date" type="date" />
                  <LabeledField label={gettext("Active")} name="active" type="checkbox" />
                </div>
              </div>
            </Modal.Body>
            <ModelEditModalFooter disabled={isSubmitting} {...props} />
          </form>
        )}
      </ModelSubmitFormik>
    </Modal>
  );
};

export default WayLinePropertiesModal;
